export function softDeleteTimestamp(): { deletedAt: string } {
  return { deletedAt: new Date().toISOString() };
}
